module.exports = __webpack_public_path__ + "assets/img/title-48d25f2c.png";